<template>
    <article class="widget concrete">
        <template v-if="widget">
            <template v-if="busy">
                <CenteredMessage :spinner="true">
                    <template>Löscht Widget...</template>
                </CenteredMessage>
            </template>
            <template v-else>
                <b-button
                    class="delete rounded-circle"
                    variant="danger"
                    size="sm"
                    @click="deleteWidget"
                >
                    <font-awesome-icon icon="trash" />
                </b-button>
                <h5>{{ widget.nicename }}</h5>
                <div class="content">
                    <!--<template v-if="widget.component_name === 'Anwesenheitsstatistik'">
                        <Anwesenheitsstatistik :url="widget.url" />
                    </template>
                    <template v-if="widget.component_name === 'Anwesenheitsverwaltung'">
                        <Anwesenheitsverwaltung :url="widget.url" />
                    </template>
                    <template v-if="widget.component_name === 'UserOverview'">
                        <UserOverview :url="widget.url" />
                    </template>-->
                    <component
                        v-bind:is="componentFile"
                        :url="widget.url"
                    ></component>
                </div>
            </template>
        </template>
    </article>
</template>

<script>
import Widget from "@/mixins/Widget/Widget";
/*import Anwesenheitsstatistik from "@/components/Widgets/Contents/Anwesenheitsstatistik";
import Anwesenheitsverwaltung from "@/components/Widgets/Contents/Anwesenheitsverwaltung";
import UserOverview from "@/components/Widgets/Contents/UserOverview";*/

import "./Widget.scss";

export default {
    name: "ConcreteWidget",
    props: ["widget"],
    mixins: [Widget],
    components: {
        /*Anwesenheitsstatistik,
        Anwesenheitsverwaltung,
        UserOverview*/
    },
    computed: {
        componentFile() {
            return () =>
                import(
                    `@/components/Widgets/Contents/${this.widget.component_name}`
                );
        }
    },
    methods: {
        deleteWidget() {
            this.$root.$emit("mv::widgets::remove", this.widget);
            this.$emit("remove", this.widget.rel_id, this.rank);
            this.busy = true;
        }
    }
};
</script>
